import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { ErrorLineDec } from 'src/app/classes/json-interface';

interface DialogData {
  arrayError: ErrorLineDec[],
  ntDialogTitle: string
}

@Component({
  templateUrl: './dialogErreurLineDec.component.html',
  styleUrls: ['./dialogErreurLineDec.component.css']
})
export class DialogErreurLineDecComponent implements OnInit {
  
  dialogTitle: string;

  /**
   * Pour ouvrir la fenetre
   * @param dialog gestion des dialog
   * @param errorLineDec tableau d'erreur de décorticage
   * @param jsArrayLineDec tableau de ligne de décorticage
   */
  public static async showErrorAnalysis(
    dialog: MatDialog, 
    errorLineDec: ErrorLineDec[], 
    noTranslatedDialogTitle: string,
  ) {
    const data: DialogData = {
      arrayError: errorLineDec,
      ntDialogTitle: noTranslatedDialogTitle
    };
    const openedDialog = dialog.open(DialogErreurLineDecComponent, { width: '800px', data: data });
    await openedDialog.afterClosed().toPromise();
  }

  matTabDataSource: ErrorLineDec[] = [];
  matTabColumn: string[] = ['LINE', 'MESSAGE'];

  constructor(
    public mHttp: HttpClient,
    public dialogRef: MatDialogRef<any>,    
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {    
    this.dialogTitle = data.ntDialogTitle;
    // Verification pour recupere les ligne web
    this.matTabDataSource.push(...data.arrayError);
    console.log('Error:', this.matTabDataSource);
  }

  onLineClick(noLine: number) {
    console.log('onLineClick ' + noLine);
  }

  ngOnInit() { }  
}
